import { render, staticRenderFns } from "./CallFlowActions.vue?vue&type=template&id=5520ce94"
import script from "./CallFlowActions.vue?vue&type=script&lang=js"
export * from "./CallFlowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports